import axios from 'axios';

/**
 * Gom mọi lời gọi API của trang chatbot CSKH.
 *
 * Backend nằm ở microservice `bot`, trả về dạng ApiResponse `{status, message, data}` nên ở đây
 * bóc sẵn phần `data` và ném lỗi khi status khác OK, để component chỉ cần lo hiển thị.
 */

const baseUrl = () => global.config.apiDomain + '/bot/web/customer-support';

const post = (path, body) =>
    axios
        .post(baseUrl() + path, body || {}, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
            const payload = res.data || {};
            if (payload.status && payload.status !== 'OK') {
                throw new Error(payload.message || 'Yêu cầu không thành công');
            }
            return payload.data;
        });

/* ------------------------------- Cấu hình ------------------------------- */

export const getSetting = () => post('/setting/get');
export const updateSetting = (setting) => post('/setting/update', setting);
export const toggleSetting = (isActive) => post('/setting/toggle', { isActive });

/* --------------------------------- FAQ ---------------------------------- */

export const listFaq = (language) => post('/faq/list', { language });
export const createFaq = (faq) => post('/faq/create', faq);
export const updateFaq = (faq) => post('/faq/update', faq);
export const deleteFaq = (id) => post('/faq/delete', { id });
export const bulkCreateFaq = (faqs, dryRun) => post('/faq/bulk-create', { faqs, dryRun });

/* ------------------------------ Hội thoại ------------------------------- */

export const listPendingConversation = (params) => post('/conversation/list-pending', params);
export const listConversation = (params) => post('/conversation/list', params);
export const statsConversation = () => post('/conversation/stats');
export const getConversation = (id) => post('/conversation/get', { id });
export const toggleConversationBotReply = (id, isEnabled) => post('/conversation/bot-reply/toggle', { id, isEnabled });
export const resolveConversation = (id) => post('/conversation/resolve', { id });

/* --------------------------- Prompt & chạy thử --------------------------- */

export const listPrompt = () => post('/prompt/list');
export const getPrompt = (promptId) => post('/prompt/get', { promptId });
export const updatePrompt = (promptId, content) => post('/prompt/update', { promptId, content });
export const preview = (userMessage, language) => post('/preview', { userMessage, language });
